import React, { useState } from 'react';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { Button, Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import {
  CURRENT_PASSWORD_REQURIED,
  CURRENT_PASSWORD_VALID,
  NEW_AND_CURRENT_PASSWORD_VALID,
  NEW_PASSWORD_REQURIED,
  PASSWORD_INCLUDE_VALID,
  PASSWORD_MATCH_REQURIED,
  RE_ENTER_PASSWORD_REQURIED,
} from '../../../../../../constants/ValidationMessageConstants';
import { getUserInfo } from '../../../../../../utils/UserInfoUtils';
import { changePasswordRequest } from '../actions';

const ChangePassword = () => {
  const [currentPasswordVisible, setCurrentPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [reEnterPasswordVisible, setReEnterPasswordVisible] = useState(false);
  const userInfo = getUserInfo();
  const dispatch = useDispatch();

  const togglePasswordVisibility = (setter, visibility) => {
    setter(!visibility);
  };

  const validationSchema = Yup.object({
    currentPassword: Yup.string().required(CURRENT_PASSWORD_REQURIED),
    newPassword: Yup.string()
      .matches(/\S/i, CURRENT_PASSWORD_VALID)
      .matches(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/, PASSWORD_INCLUDE_VALID)
      .notOneOf([Yup.ref('currentPassword'), null], NEW_AND_CURRENT_PASSWORD_VALID)
      .required(NEW_PASSWORD_REQURIED),
    reEnterPassword: Yup.string()
      .oneOf([Yup.ref('newPassword'), null], PASSWORD_MATCH_REQURIED)
      .required(RE_ENTER_PASSWORD_REQURIED),
  });

  const initialValues = {
    currentPassword: '',
    newPassword: '',
    reEnterPassword: '',
  };

  const onSubmit = (values, { setSubmitting }) => {
    let params = {
      userId: userInfo?.UserId,
      oldPassword: values?.currentPassword,
      newPassword: values?.newPassword,
    };
    dispatch(changePasswordRequest(params));
    setSubmitting(false);
  };

  return (
    <div className="profile-wrapper">
      <Row>
        <Col md="8">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
            validateOnBlur={false}
            validateOnChange={false}
          >
            {({ isSubmitting }) => (
              <Form>
                <Row>
                  <Col md="12">
                    <div className="fw-bold fnt-18 mb-4">Change Password</div>
                  </Col>
                  <Col md="6">
                    <div className="mb-2">
                      <label htmlFor="currentPassword" className="form-label">
                        Current Password
                      </label>
                      <div className="position-relative">
                        <Field
                          type={currentPasswordVisible ? 'text' : 'password'}
                          id="currentPassword"
                          name="currentPassword"
                          placeholder="Enter current password"
                          className="form-control"
                          autoComplete="current-password"
                          data-lpignore="true"
                        />
                        <span
                          className="field-icon fnt-18"
                          onClick={() => togglePasswordVisibility(setCurrentPasswordVisible, currentPasswordVisible)}
                        >
                          {currentPasswordVisible ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                        </span>
                        <ErrorMessage name="currentPassword" component="div" className="invalid-feedback d-block" />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="6">
                    <div className="mb-2">
                      <label htmlFor="newPassword" className="form-label">
                        New Password
                      </label>
                      <div className="position-relative">
                        <Field
                          type={newPasswordVisible ? 'text' : 'password'}
                          id="newPassword"
                          name="newPassword"
                          placeholder="Enter new password"
                          className="form-control"
                          autoComplete="new-password"
                          data-lpignore="true"
                        />
                        <span
                          className="field-icon fnt-18"
                          onClick={() => togglePasswordVisibility(setNewPasswordVisible, newPasswordVisible)}
                        >
                          {newPasswordVisible ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                        </span>
                        <ErrorMessage name="newPassword" component="div" className="invalid-feedback d-block" />
                      </div>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-2">
                      <label htmlFor="reEnterPassword" className="form-label">
                        Re-Enter Password
                      </label>
                      <div className="position-relative">
                        <Field
                          type={reEnterPasswordVisible ? 'text' : 'password'}
                          id="reEnterPassword"
                          name="reEnterPassword"
                          placeholder="Enter re-enter password"
                          className="form-control"
                          autoComplete="new-password"
                          data-lpignore="true"
                        />
                        <span
                          className="field-icon fnt-18"
                          onClick={() => togglePasswordVisibility(setReEnterPasswordVisible, reEnterPasswordVisible)}
                        >
                          {reEnterPasswordVisible ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
                        </span>
                        <ErrorMessage name="reEnterPassword" component="div" className="invalid-feedback d-block" />
                      </div>
                    </div>
                  </Col>
                  <Col md="6" className="mt-3">
                    <Button type="submit" variant="primary" disabled={isSubmitting}>
                      Save Changes
                    </Button>
                  </Col>
                </Row>
              </Form>
            )}
          </Formik>
        </Col>
      </Row>
    </div>
  );
};

export default ChangePassword;
